import React, { useState, useEffect } from "react";
import TemplateEdit from "../TemplateEdit";

const GroupBlockEdit = ({ data: initialData, onChange: onChangeProp, id }) => {
    const [data, setData] = useState({
        blocks: [],
        options: {},
    });

    // Mise à jour des données si les props changent
    useEffect(() => {
        setData(initialData);
    }, [initialData]);

    const handleChange = (template) => {
        const newData = { ...data, blocks: template.blocks };
        setData(newData);
        onChangeProp(newData);
    };

    const setOptions = (options) => {
        const newData = { ...data, options };
        setData(newData);
        onChangeProp(newData);
    };

    const renderGapSlider = () => {
        if (data.options?.direction !== "row") return null;
        const options = data.options;
        return (
            <div
                className="valign-wrapper container"
                style={{ display: "flex", gap: 20, justifyContent: "center" }}
            >
                <label>Espacement</label>
                <input
                    type="range"
                    min="0"
                    max="50"
                    value={options?.gap || 0}
                    onChange={(e) =>
                        setOptions({ ...options, gap: e.target.value })
                    }
                    style={{
                        borderRadius: "15px",
                        backgroundColor: "#c2c0c2",
                        borderColor: "transparent",
                    }}
                />
            </div>
        );
    };

    const renderOptions = () => {
        const options = data.options;
        return (
            <div className="switch center">
                <label>
                    Vertical
                    <input
                        type="checkbox"
                        checked={data.options?.direction === "row"}
                        onChange={(e) =>
                            setOptions({
                                ...options,
                                direction: e.target.checked ? "row" : "column",
                            })
                        }
                    />
                    <span className="lever"></span>
                    Horizontal
                </label>
                {renderGapSlider()}
            </div>
        );
    };

    return (
        <div style={{ width: "100%" }}>
            {renderOptions()}
            <TemplateEdit
                template={{ blocks: data.blocks, id }}
                onChange={handleChange}
                groupId={id}
            />
        </div>
    );
};

export default GroupBlockEdit;
